import { FormControl, FormGroup } from '@angular/forms';
import {
	CommunicationChannel,
	CommunicationEndpoint,
	ICommunicationTemplate,
} from '@internal-models/communication-template.model';
import { Action } from '@shared-libs/enums';
import { SharedFormValidators } from '@shared-libs/form-validators';
import { IFormGroup } from '@shared-libs/interfaces';
import { cloneDeep } from 'lodash';

export class CustomCommunicationTemplateFormFactory {
	public static create(template: ICommunicationTemplate, action: Action): IFormGroup<ICommunicationTemplate> {
		const form = new FormGroup({
			channel: new FormControl({ value: template.channel, disabled: action !== Action.CREATE }, [
				SharedFormValidators.required,
			]),
			endpoint: new FormControl(template.endpoint, [SharedFormValidators.required]),
			messageType: new FormControl(template.messageType, [SharedFormValidators.required]),
			customName: new FormControl(template.customName, [SharedFormValidators.required]),
		}) as IFormGroup;

		const setEndpointBasedOnChannel = (init: boolean) => {
			if (form.get('channel').value === CommunicationChannel.Sms) {
				form.get('endpoint').patchValue(CommunicationEndpoint.Client);
				form.get('endpoint').disable({ emitEvent: false });
			} else if (init === false) {
				form.get('endpoint').patchValue(null);
				form.get('endpoint').enable({ emitEvent: false });
			}
		};

		form.get('channel').valueChanges.subscribe(() => {
			setEndpointBasedOnChannel(false);
		});
		setEndpointBasedOnChannel(true);

		return form;
	}

	public static getValue(form: IFormGroup<ICommunicationTemplate>): Partial<ICommunicationTemplate> {
		const endpointDisabled = form.get('endpoint').disabled;
		if (endpointDisabled) {
			form.get('endpoint').enable({ emitEvent: false });
		}
		form.get('channel').enable({ emitEvent: false });
		const value = cloneDeep(form.value);
		form.get('channel').disable({ emitEvent: false });
		if (endpointDisabled) {
			form.get('endpoint').disable({ emitEvent: false });
		}
		return value;
	}
}
